export default function CoreValues() {
    return (
      <div className="bg-gray-50 rounded-lg p-8 mb-16">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Our Core Values</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-blue-600 text-3xl mb-4">
              <i className="fas fa-lightbulb"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Innovation</h3>
            <p className="text-gray-600">We constantly explore new technologies and approaches to deliver cutting-edge solutions.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-blue-600 text-3xl mb-4">
              <i className="fas fa-handshake"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Integrity</h3>
            <p className="text-gray-600">We build trust through transparency, honesty, and ethical business practices.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="text-blue-600 text-3xl mb-4">
              <i className="fas fa-users"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Collaboration</h3>
            <p className="text-gray-600">We work closely with clients as partners to achieve shared success.</p>
          </div>
        </div>
      </div>
    );
  }